import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'me'
const verb = 'get'

class OspreyMeInfo extends BaseAction {

    constructor() {
        const id = '37794b54-0387-11e7-afd6-f7dbf33239d5'
        const path = `/${resource}`
        super(resource, verb, path, id)

        this.onError = () => true
    }

    get() {
        return fetchContentIfNeeded(this)
    }
}

export default class Me {

    constructor() {
        this._action = new OspreyMeInfo()
    }

    get info() {
        return this._action
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/me/index.js